import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemPermissionsRoute: InvariantJiraRoute = {
	name: 'global-settings-system-permissions',
	path: '/secure/admin/GlobalPermissions([!%]?[\\w]*).jspa',
};
